import api from './api';

class UserService {
  // Get all users
  static async getUsers() {
    try {
      const response = await api.get('/api/v1/users/');
      const users = Array.isArray(response.data) ? response.data : response.data.users || [];
      return { success: true, data: users };
    } catch (error) {
      console.error('Error fetching users:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Failed to fetch users'
      };
    }
  }

  // Create a new user
  static async createUser(userData) {
    try {
      const payload = {
        email: userData.email,
        username: userData.username,
        firstname: userData.firstname,
        lastname: userData.lastname,
        password: userData.password,
        user_type: userData.user_type,
        is_active: true,
        is_verified: true,
        is_superuser: userData.user_type === 'SUPER_ADMIN'
      };

      const response = await api.post('/api/v1/users/users/add-user', payload);
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Error creating user:', error);
      return {
        success: false,
        error: error.response?.data?.detail || error.response?.data?.message || 'Failed to create user',
        fieldErrors: error.response?.data?.errors
      };
    }
  }

  // Update a user
  static async updateUser(userId, userData) {
    try {
      const response = await api.put(`/api/v1/users/${userId}`, userData);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || 'Failed to update user'
      };
    }
  }

  // Delete a user
  static async deleteUser(userId) {
    try {
      await api.delete(`/api/v1/users/${userId}`);
      return { success: true };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || 'Failed to delete user'
      };
    }
  }

  // Check if username is unique
  static async checkUsernameUnique(username) {
    try {
      const response = await api.get(`/api/v1/users/check-username?username=${username}`);
      return { success: true, isUnique: response.data.isUnique };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || 'Failed to check username'
      };
    }
  }

  // Mock implementation for development if backend is not ready
  static mockCreateUser(userData) {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          success: true,
          data: {
            id: 'mock-id-' + Math.floor(Math.random() * 1000),
            name: userData.name,
            email: userData.email,
            username: userData.username,
            role: userData.role,
            status: 'active',
            created_at: new Date().toISOString()
          }
        });
      }, 800);
    });
  }
}

export default UserService;
